import React, { useState } from 'react';
import axios from 'axios';
import './FirstTimeConsentModal.css';

const API_URL = '/api';

function FirstTimeConsentModal({ auth, isOpen, onAccepted, onDecline, onOpenLegal }) {
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleAccept = async () => {
    if (!agreed || submitting) return;

    setSubmitting(true);
    setError('');

    try {
      const response = await axios.post(
        `${API_URL}/user/accept-terms`,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth?.token}`
          }
        }
      );

      if (onAccepted) {
        onAccepted(response.data);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to record your consent. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card consent-modal-card">
        <h3 className="consent-modal-title">Welcome!</h3>
        <p className="consent-modal-subtitle">
          Please review and accept our terms before accessing your dashboard.
        </p>

        {error && <div className="settings-alert settings-alert-danger">{error}</div>}

        <label className="consent-checkbox-row">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span className="consent-checkbox-label">
            I agree to the{' '}
            <button
              type="button"
              className="consent-inline-link-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (onOpenLegal) onOpenLegal('terms');
              }}
            >
              Terms of Service
            </button>{' '}
            and{' '}
            <button
              type="button"
              className="consent-inline-link-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (onOpenLegal) onOpenLegal('privacy');
              }}
            >
              Privacy Policy
            </button>
            .
          </span>
        </label>

        <div className="consent-modal-actions">
          <button
            type="button"
            className="button button-secondary consent-modal-btn"
            onClick={onDecline}
            disabled={submitting}
          >
            Decline &amp; Sign Out
          </button>
          <button
            type="button"
            className="button button-primary consent-modal-btn"
            onClick={handleAccept}
            disabled={!agreed || submitting}
          >
            {submitting ? 'Saving...' : 'Accept & Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FirstTimeConsentModal;
